export default "__VITE_PUBLIC_ASSET__9bec3977__"